/**************************************************
 * Nombre:       Formulario_Varietal_Fotos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {AgricultureOutlined, CategoryOutlined, EmojiFoodBeverageOutlined, FlagOutlined} from "@mui/icons-material";
import IngresoSelect from "../../../Modulo_formularios/Componentes/IngresoSelect";
import {useEffect, useState} from "react";
import {obtenerCol} from "../../../Servicios/BD/obtenerCol";
import IngresoImagenCropLista from "../../../Modulo_formularios/Componentes/IngresoImagenCropLista";

const Formulario_Varietal_Fotos = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={12}>
                    <IngresoImagenCropLista  nombre={'Imagenes'} dato={'imgs'} {...props}/>
                </Grid>





            </Grid>

        </form>

    )

}
export default Formulario_Varietal_Fotos